import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from '@odmonorepo/core-components';
import { Card, Stack } from 'react-bootstrap';
import { useAtom } from 'jotai';
import { isTermLoan } from '../OfferReview/OfferReview';
import { useApplication } from 'merchant-api/unified';
import { delayedFundingDate } from 'merchant-api/derived';
import { DelayedFundingMessage } from '../../../LoanApp/Cards/DelayedFundingNotification';


export const CheckoutSuccess = () => {
  const [termLoan] = useAtom(isTermLoan);
  const { applicationData } = useApplication();
  const fundingDate = delayedFundingDate(applicationData);

  return (
    <div className="background-wrapper text-center">
      <div className="h3 mb-5 mx-3">
        <FormattedMessage id="checkoutSuccess.title" />
      </div>
      <Stack gap={5} className="pt-3 m-0 mx-auto" style={{ maxWidth: 600 }}>
        <Card className="pt-4 pb-4 px-4" >
          <div className="mx-5 px-sm-5 py-5 text-start">
            {fundingDate ? (
              <DelayedFundingMessage fundingDate={fundingDate} />
            ) : !termLoan ? (
              <>
              <FormattedMessage id="checkoutSuccess.loc.notice1" />
              </>
            ) : (
              <>
              <FormattedMessage id="checkoutSuccess.tl.notice1" />
              <sup>
                <FormattedMessage id="checkoutSuccess.tl.notice2" />
              </sup>
              </>
            )}
            <div className="text-center mt-3">
              <Button type="button" className="mt-4 mb-1 mx-auto" href={"/"}>
                <FormattedMessage id="checkoutSuccess.button" />
              </Button>
            </div>
          </div>
        </Card>
      </Stack>
    </div>
  )
}

export default CheckoutSuccess;
